exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".searchInput { position: relative; }\n.dropdown { max-height: 300px; overflow-y: auto; }\n.dropdown { display: block; position: absolute; top: 45px; left: 0; width: 600px; padding: 0; border-radius: 0 0 5px 5px; box-shadow: 0px 0px 5px rgba(0,0,0,0.4); background: #fff; z-index: 100; }\nli.searchResult { padding: 15px 7px 15px 15px; margin: 0; font-size:15px;}\nspan.productNumber { font-size:12px;}\nli.searchResult:hover { background-color: #575757; color: #ffffff;}\n.full-width { width: 100%;}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/search-products/search-input/search-input.component.css
// module id = ../../../../../src/app/shared/search-products/search-input/search-input.component.css
// module chunks = main